
const config = {
    selectors: {
        root: '.navigation__main-nav-item-parent .navigation-link-section',
    },
};


class NavigationLinkSection {

    static sort() {
        const lists = document.querySelectorAll(config.selectors.root);

        for(const list of lists) {
            if(list.dataset.sortByUrl == 'true') {
                Array.prototype.slice.call(list.children)
                    .map(function (x) { return list.removeChild(x); })
                    .sort(function (x, y) { return x.children[0] && y.children[0] && x.children[0].getAttribute('href') > y.children[0].getAttribute('href') ? 1 : -1; })
                    .forEach(function (x) { list.appendChild(x); });
            } else {
                Array.prototype.slice.call(list.children)
                    .map(function (x) { return list.removeChild(x); })
                    .sort(function (x, y) { return x.children[0] && y.children[0] && x.children[0].innerText > y.children[0].innerText ? 1 : -1; })
                    .forEach(function (x) { list.appendChild(x); });
            }

        }
    }
}

export default NavigationLinkSection;